import React, { Component } from 'react';
import axios from "axios";
import {appConfig} from "./../../tools/AppConfig";
import Form from 'react-validation/build/form';
import Button from 'react-validation/build/button';
import Waiting from './../waiting';
import './../../custom.css';
import './../../pages/invoice.css';

class cash extends Component {
      constructor(props) {
        super(props);
        this.state = {
            waiting: false,
            userData: props.userData,
            deliveryNeed: props.deliveryNeed,
            deliveryData: props.deliveryData,
            phone: '',
        };
        this.getFirstName = this.getFirstName.bind(this);
        this.getLastName = this.getLastName.bind(this);
        this.handelPhoneChange = this.handelPhoneChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
      }

    getFirstName(fullName) {
    var namesArr = fullName.split(" ");
    return namesArr[0]
    }
    getLastName(fullName) {
    var namesArr = fullName.split(" ");
    return namesArr[namesArr.length - 1];
    }
  handelPhoneChange(e) {
    this.setState({phone: e.target.value});
  }
  handleSubmit(event) {
    //--- strat waiting
    this.setState({waiting: true});
    let url;
    if(this.props.sourcePage ==='invoice'){
        url = appConfig.getServerUrl() + '/invoice2/'+ this.state.userData.token;
    }else if(this.props.sourcePage ==='product'){
        url = appConfig.getServerUrl() + '/product2/'+ this.state.userData.token;
    }
    
    let paymentDict;
    if(this.props.sourcePage === 'invoice'){
        paymentDict = {
            "source" : {'subtype': 'CASH', 'identifier': 'cash'},
            "shipping_data": {
                'apartment': this.state.deliveryData.apartment,
                'email': this.state.userData.order_email,
                'floor': this.state.deliveryData.floor,
                'first_name': this.getFirstName(this.state.userData.order_full_name),
                'street': this.state.deliveryData.street,
                'building': this.state.deliveryData.building,
                'phone_number': this.state.userData.order_phone,
                'postal_code': this.state.deliveryData.postal_code,
                'city': this.state.deliveryData.city,
                'country': this.state.deliveryData.country,
                'last_name': this.getLastName(this.state.userData.order_full_name),
                'state': this.state.deliveryData.state,
                'extra_description': this.state.deliveryData.notes
            },
            "shipping_details": {
                'delivery_type': 'payment_collection',
                'notes': this.state.deliveryData.notes
            },
            "token": this.state.userData.token,
            "integration_id": this.state.userData.integration_ids.CASH
        };
    }else if(this.props.sourcePage === 'product'){
        paymentDict = {
            "order_data": {
                "delivery_needed": this.state.deliveryNeed,
                "amount_cents": this.state.userData.amount * this.props.quantity * 100,
                "currency": this.state.userData.currency,
                "shipping_data": {
                    "first_name": this.getFirstName(this.state.deliveryData.name),
                    "last_name": this.getLastName(this.state.deliveryData.name),
                    "phone_number": this.state.deliveryData.phone,
                    "email": this.state.deliveryData.email,
                    "street": 'NA',
                    "city": 'NA',
                    "country": 'NA',
                    "postal_code": 'NA',
                    "state": "NA"
                },
                "items": [{
                    "name": this.state.userData.product.product_name,
                    "amount_cents": this.state.userData.amount * 100,
                    "quantity": this.props.quantity,
                }]
            },
            "source" : {'subtype': 'CASH', 'identifier': 'cash'},
            "token": this.state.userData.token,
            "integration_id": this.state.userData.integrations.CASH
        };
        paymentDict.order_data.shipping_data.country = this.state.deliveryData.country;
        paymentDict.order_data.shipping_data.state = this.state.deliveryData.state;
        paymentDict.order_data.shipping_data.city = this.state.deliveryData.city;
        paymentDict.order_data.shipping_data.building = this.state.deliveryData.building;
        paymentDict.order_data.shipping_data.street = this.state.deliveryData.street;
        paymentDict.order_data.shipping_data.floor = this.state.deliveryData.floor;
        paymentDict.order_data.shipping_data.apartment = this.state.deliveryData.apartment;
        paymentDict.order_data.shipping_data.postal_code = this.state.deliveryData.postal_code;
        paymentDict.order_data.shipping_data.extra_description = this.state.deliveryData.notes;
    }
    let jsonPaymentDict = JSON.stringify(paymentDict);
    let config = {
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };
    axios.post(url, jsonPaymentDict, config)
    .then((resp) => {
        if(resp.data.success === 'true' || resp.data.success === true){
            //succes without url and not delivery
            this.props.setReqComplete({head: 'Scheduling Successful', body:'Courrier will get in touch to determine the exact collection time.'});
        }else{
            //succes = false
            this.props.setReqComplete({head: '', body: resp.data.error});
        }
    })
    .catch((err) => {
        //--- end waiting
        this.setState({waiting: false});
        if(err.response.status === 404){
            alert('Please check your internet connection and try again.');
        }
    });
    event.preventDefault();
  }

  render() {
    return (
        <div className="">
            <div className="delivery_new" id="card_content">
                {this.state.waiting?
                    <Waiting height="68px" />
                :
                    <Form onSubmit={this.handleSubmit}>
                        <p>Please click on the "Confirm" button to schedule the cash collection.</p>
                        <div className='text-center'>
                            <Button className="confirmBtnNew">Confirm</Button>
                        </div>
                    </Form> 
                }               
            </div>
        </div>
    );
  }
}

export default cash;
